import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Block } from "../block.js";
import { Rule } from "../rule.js";
/**
 * @public
 */
export class FontFaceRule extends Rule {
    static of(declarations) {
        return new FontFaceRule(Array.from(declarations));
    }
    _style;
    constructor(declarations) {
        super("font-face");
        this._style = Block.of(declarations.filter((declaration) => declaration._attachParent(this)));
    }
    get style() {
        return this._style;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            style: this._style.toJSON(),
        };
    }
    toString() {
        const style = this._style.toString();
        return `@font-face {${style === "" ? "" : `\n${String.indent(style)}\n`}}`;
    }
}
/**
 * @public
 */
(function (FontFaceRule) {
    function isFontFaceRule(value) {
        return value instanceof FontFaceRule;
    }
    FontFaceRule.isFontFaceRule = isFontFaceRule;
    /**
     * @internal
     */
    function fromFontFaceRule(json) {
        return Trampoline.done(FontFaceRule.of(Block.from(json.style)));
    }
    FontFaceRule.fromFontFaceRule = fromFontFaceRule;
})(FontFaceRule || (FontFaceRule = {}));
//# sourceMappingURL=font-face.js.map